import type { SponsorProject } from "../../hooks";
import { isNotionProjectUrl } from "./notionProjectUrl";
import { SponsorProjectSelect } from "./SponsorProjectSelect";

interface SponsorProjectFieldProps {
  labelId: string;
  sponsorProjects: SponsorProject[];
  loading: boolean;
  error: string | null;
  value: string | null;
  onChange: (sponsorProject: SponsorProject) => void;
  onRetry: () => void;
}

export function SponsorProjectField({
  labelId,
  sponsorProjects,
  loading,
  error,
  value,
  onChange,
  onRetry,
}: SponsorProjectFieldProps) {
  if (loading) {
    return (
      <p className="text-[var(--color-text-secondary)] text-sm">
        プロジェクトを読み込み中...
      </p>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-between gap-3">
        <p className="text-[var(--color-text-danger)] text-sm">
          プロジェクトの一覧を取得できませんでした
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 cursor-pointer rounded-md border border-[var(--color-border-default)] bg-white px-3 py-1.5 text-[var(--color-text-primary)] text-sm"
        >
          再読み込み
        </button>
      </div>
    );
  }

  const hasSelectableProject = sponsorProjects.some((sponsorProject) =>
    isNotionProjectUrl(sponsorProject.projectUrl),
  );
  if (!hasSelectableProject) {
    return (
      <p className="text-[var(--color-text-danger)] text-sm">
        詳細URLにNotionのURLが登録されたプロジェクトがありません。管理画面のプロジェクトの「詳細URL」にNotionのURLを登録すると、タームを作成できます。
      </p>
    );
  }

  return (
    <>
      <SponsorProjectSelect
        id="sponsorProject"
        labelId={labelId}
        sponsorProjects={sponsorProjects}
        value={value}
        onChange={onChange}
      />
      <p className="mt-1 text-[var(--color-text-secondary)] text-xs">
        選択したプロジェクトの詳細URLを、案件NotionのURLとしてタームに保存します。作成後は変更できません。
      </p>
    </>
  );
}
